import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { timer } from 'rxjs';


@Directive({
  selector: '[lpClickOutside]'
})
export class LpClickOutsideDirective {

  @Input() clickOutsideEnabled:boolean = true;
  @Input() delay: number;

  @Output() clickOutside = new EventEmitter<MouseEvent>();
  constructor(private el:ElementRef) {}

  @HostListener('document:click',['$event'])
  public onDocumentClick(event:MouseEvent){
    if(this.clickOutsideEnabled){
      const target = event.target as HTMLElement;
      if(target && !this.el.nativeElement.contains(target)){
          if(this.delay){
            timer(this.delay).subscribe(()=>{
              this.clickOutside.emit(event)
            })
            return
          }
          this.clickOutside.emit(event)
      }
    }
  }

}
